<template>
  <div class="home">
    <Tabbar title="云养狗" />
    <van-swipe :autoplay="3000" indicator-color="rgb(236, 105, 65)" v-if="arrSlider.length>0">
      <van-swipe-item v-for="(item,index) in arrSlider" :key="index">
        <img :src="item.image" class="home_banner" />
      </van-swipe-item>
    </van-swipe>
    <ul class="goods-list">
      <li v-for="(item,index) in arr" :key="index">
        <div
          :class="(item.id==1?'pet-img1':'')||(item.id==2?'pet-img2':'')||(item.id==3?'pet-img3':'')||(item.id==4?'pet-img4':'')||(item.id==5?'pet-img5':'')||(item.id==6?'pet-img6':'')||(item.id==7?'pet-img7':'')||(item.id==8?'pet-img8':'')||(item.id==9?'pet-img9':'')"
        >
          <img :src="item.image" class="image" />
        </div>
        <div class="content-chunk">
          <div class="top">
            <span>{{item.name}}</span>
          </div>
          <div class="petItem">价值：{{item.start_price}}-{{item.end_price}}</div>
          <div class="petItem">领养时间：{{item.start_time|formatDate}}-{{item.end_time|formatDate}}</div>
          <div class="petItem">预约/即抢狗粮：{{item.appoint}}/{{item.purchase}}</div>
          <div class="petItem">智能合约收益：{{item.day}}天/{{(item.day*item.bonus_rate*100).toFixed(0)}}%</div>
        </div>
        <button
          class="button"
          :disabled="(item.state==2&&true)||(item.state==4&&true)||(item.state==1&&item.isappoint==1&&true)"
          @click="change(item)"
          :style="(item.state==1&&'background:#22AC38')||(item.state==2&&'background:#A0A0A0')||(item.state==3&&'background:#FD4610')||(item.state==4&&'background:#5A8CFB')||(item.state==5&&'background:#A064BC')"
        >{{item.desc}}</button>
      </li>
    </ul>
    <!-- 匹配中 -->
    <van-dialog v-model="show1"  class="w-loading">
      <img src="../../assets/images/home/loading.gif" alt />
    </van-dialog>
    <!-- 遮罩层 -->
    <van-dialog v-model="show" :showConfirmButton="false">
      <img src="../../assets/images/home/success.png" alt v-if="buyStatus==1" />
      <img src="../../assets/images/home/fail.png" alt v-else-if="buyStatus==2" />
      <div @click="show=false">
        <van-icon name="close" size="30" />
      </div>
    </van-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import { Toast } from "vant";
// bannerList
import {
  petList,
  appoint,
  addOrder,
  bannerList,
  getOrderState
} from "@/api/home";
import axios from "axios";
import Tabbar from "@/components/tabbar";

export default {
  components: { Tabbar },
  data() {
    return {
      arr: [],
      resSeconds: "",
      show: false,
      show1: false,
      tips: "",
      buyStatus: 0,
      arrSlider: [],
      endTime: "",
      timer: ""
    };
  },
  created() {
    this.getList();
    bannerList().then(res => {
      this.arrSlider = res;
    });
    let stateId = localStorage.getItem("stateId");
    if (stateId) {
      setInterval(() => {
        this.getResult();
      }, 10000);
    }
  },
  filters: {
    formatDate(time) {
      return time.split(":")[0] + ":" + time.split(":")[1];
    }
  },
  mounted() {},
  methods: {
    //转换时间
    getS(item) {
      let H = item.split(":")[0] * 3600;
      let M = item.split(":")[1] * 60;
      let S = item.split(":")[2];
      return Number(H) + Number(M) + Number(S);
    },
    getList() {
      // 清除之前存在的计时器
      this.arr.forEach(cat => {
        if (cat.outerTimer) {
          clearInterval(cat.outerTimer);
        }
      });
      petList().then(res => {
        this.arr = res.data;
        let curSeconds = this.getS(res.time);
        this.endTime = res.time;
        res.data.forEach(item => {
          item.resSeconds = this.getS(item.start_time);
          item.time = item.resSeconds - curSeconds;
          if (item.time >= 0) {
            item.outerTimer = setInterval(() => {
              if (item.time <= 120 && item.time > 0) {
                item.desc = "抢购倒计时:" + Number(item.time) + "s";
                item.state = 100;
              }
              if (item.time == 0) {
                clearInterval(item.outerTimer);
                item.outerTimer = null;
                item.desc = "抢购";
                item.state = 3;
              }
              item.time--;
            }, 1000);
          }
        });
      });
    },
    change(item) {
      if (item.state == 3) {
        var that_ = this;
        addOrder({ type: item.id })
          .then(res => {
            localStorage.setItem("stateId", res.res.id);
            this.stateId = res.res.id;
            this.show1=true;
            item.desc = "已抢购";
            item.state = 4;
            this.timer = setInterval(() => {
              setTimeout(() => {
                this.getResult();
              }, 0);
            }, 10000);
          })
          .catch(err => {});
      } else {
        appoint({ type: item.id }).then(res => {
          Toast("预约成功");
          this.getList();
        });
      }
    },
    getResult() {
      let that_ = this;
      let stateId = localStorage.getItem("stateId");
      if(stateId){  
      getOrderState(stateId).then(res => {
        if (res.errcode == 0) {
          let resp = res.res;
          if (resp.is_success == 2) {
            that_.show1 = false;
            that_.show = true;
            that_.buyStatus = resp.is_success;
            clearInterval(that_.timer);
            localStorage.removeItem("stateId");
            that_.getList();
          } else if (resp.is_success == 1) {
            that_.show1 = false;
            that_.show = true;
             that_.buyStatus = resp.is_success;
            clearInterval(that_.timer);
            localStorage.removeItem("stateId");
            that_.getList();
          }
        } else {
          clearInterval(that_.timer);
        }
      });
      }
    },
  },
  beforeDestroy() {
    Toast.clear();
    //页面关闭时清除定时器
    if (this.timer) {
      //如果定时器在运行则关闭
      clearInterval(this.timer);
    }
  }
};
</script>

<style lang="less" scoped>
.home {
  font-size: 12px;
  background: url("~@/assets/images/home/homeBg.png");
  color: white;
  [class*="van-hairline"]::after {
    border: 0;
  }
  width: 100%;
  padding-bottom: 30px;
  min-height: 640px;
  .home_banner {
    width: 100%;
    height: 150px;
    margin: 0px auto;
  }
  .goods-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 0 2%;
    text-align: center;
    margin-bottom: 30px;
    li {
      width: 49%;
      padding-top: 20px;
      background: #ffa300;
      color: #694102;
      margin-top: 12.5px;
      font-size: 11px;
      border-radius: 5px;
      .content-chunk {
        text-align: left;
        padding: 0 3px;
      }
      .pet-img {
        text-align: center;
      }
      .image {
        width: 86.5px;
        height: 95px;
        border-radius: 5px 5px 0 0;
        display: inline-block;
        text-align: center;
      }
      .button {
        font-size: 16px;
        width: 148px;
        margin-top: 12px;
        margin-bottom: 20px;
        text-align: center;
        line-height: 30px;
        height: 30px;
        background: #4b8c28;
        border: none;
        border-radius: 20px;
        color: #fff;
      }
      .content-chunk {
        margin-top: 10px;
      }
      .top {
        font-size: 16px;
        color: #000;
        font-weight: bold;
        margin-bottom: 10px;
      }
      .petItem {
        margin-top: 5px;
      }
    }
  }
  .van-dialog {
    // background: rgba(0,0,0,0.7);
    background: transparent;
    height: 100%;
    width: 90%;
    text-align: center;
    height: 50%;
    /deep/ .van-button {
      color: #fff;
      background: transparent;
      margin-top: 4%;
    }
    /deep/ .van-dialog__content {
      background: transparent;
    }
    img {
      width: 200px;
      height: 200px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/home/home.vue